import { render } from "./CharacterView.vue?vue&type=template&id=49a78dea&scoped=true"
import script from "./CharacterView.vue?vue&type=script&lang=js"
export * from "./CharacterView.vue?vue&type=script&lang=js"

import "./CharacterView.vue?vue&type=style&index=0&id=49a78dea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49a78dea"

export default script